import { usernameClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * Better-auth client for web
 * Handles authentication via session cookies
 */

// Extract base URL from VITE_API_URL (removes /graphql if present)
const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4000/graphql";
const BASE_URL = API_URL.replace(/\/graphql$/, "");

export const authClient = createAuthClient({
  baseURL: BASE_URL,
  plugins: [
    // @ts-expect-error - username plugin has type incompatibilities with Better Auth client types
    usernameClient(),
  ],
}) as ReturnType<typeof createAuthClient>;

let ending = false;

/**
 * Ends the session from outside React, for a server that has stopped accepting it — signing in
 * on another device is the one that matters, since no retry can make this token current again.
 * Reloads rather than routes, as the callers sit outside the router.
 */
export async function endSession(): Promise<void> {
  if (ending) return;
  ending = true;

  try {
    await authClient.signOut();
  } finally {
    window.location.href = "/login";
  }
}
